module.exports = __webpack_public_path__ + "static/media/pms-icon.68aca7d3.png";